export const SOCIAL_SERVICE_OPTIONS = [
  { label: "Linkedin", value: "linkedin" },
  { label: "Facebook", value: "facebook" },
  { label: "Twitter", value: "twitter" },
  { label: "Instagram", value: "instagram" },
  { label: "Pinterest", value: "pinterest" },
  { label: "Youtube", value: "youtube" },
  { label: "Vimeo", value: "vimeo" },
  { label: "Business Website", value: "business-website" },
  { label: "Personal Website", value: "personal-website" },
  { label: "Other", value: "other" },
];
